export const FILTER_SAVED = 'user/filter_saved';
